import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { routes } from '@routes';
import { useNavigate } from 'react-router';

type TProps = {
  currentTab: string;
};

export const Tabs = ({ currentTab }: TProps) => {
  const navigate = useNavigate();
  return (
    <HeaderSwitchWrapper key="tabSwitcher">
      <SwitchButton active={currentTab === 'SMS Countries'} onClick={() => navigate(routes.adminSMSCountries.make())}>
        SMS Countries
      </SwitchButton>
      <SwitchButton active={currentTab === 'SMS Whitelist'} onClick={() => navigate(routes.adminSMSWhitelist.make())}>
        SMS Whitelist
      </SwitchButton>
    </HeaderSwitchWrapper>
  );
};
